<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <!-- <h5 class="card-category"></h5> -->
                        <h3 class="card-title">Pretplatnici ({{ totalRecords }})
                            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="whitelistCustomer = {}; editWhitelist = true">Novi pretplatnik</base-button>
                        </h3>

                    </template>
                    <div class="row">
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Ime</h4>
                            <base-input type="text" v-model="filter.customerName" placeholder="Ime">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <!-- </div> -->

                        <!-- <div class="row"> -->

                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.status" class="select-primary" clearable name="status">
                                    <el-option v-for="s in statuses" class="select-primary" :label="s.name"
                                        :value="s.status" :key="s.status"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getWhitelist()">Pretraži</base-button>
                            <!-- </card> -->
                        </div>
                    </div>
                    <el-table :data="whitelist" v-loading="ticketsLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">
                        <el-table-column min-width="100" prop="customer_name" label="Ime" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.customerName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90" prop="plates" label="Tablice" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="110" prop="date_from" label="Od" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.dateFrom)).toLocaleString("de-De") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="110" prop="date_to" label="Do" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.dateTo)).toLocaleString("de-De") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="110" prop="stamp" label="Ugovor" sortable="custom">
                            <template slot-scope="scope">
                                <span v-if="scope.row.contractExpireLong > 0">{{ (new
                                    Date(scope.row.contractExpireLong)).toLocaleString("de-De") }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column min-width="110" prop="stamp" label="Kreirano" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-De") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="time_stamp" label="Datum izmene" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.timeStamp)).toLocaleString("de-De") }}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column min-width="100" prop="whitelist_type_id" label="Tip" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.whitelistType?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="110" prop="status" label="Status" sortable="custom">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0 || scope.row.status === 5"
                                    style="background-color: green;">{{ scope.row.statusName }}</span>
                                <span v-if="scope.row.status === 3 || scope.row.status === 4"
                                    style="background-color: orange; color: black">{{ scope.row.statusName }}</span>
                                <span v-if="scope.row.status === 6" style="background-color: blue;">{{
                                    scope.row.statusName }}</span>

                                <span v-if="scope.row.status === 2 || scope.row.status === 1"
                                    style="background-color: red;">{{ scope.row.statusName }}</span>

                            </template>
                        </el-table-column>
                        <!--
                        <el-table-column min-width="100" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="60" prop="price" label="Cena">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="paymentStatus" label="Status">
                            <template slot-scope="scope">
                                <span>{{ scope.row.paymentStatus.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="ticketNumber" label="ID">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ticketNumber }}</span>
                            </template>
                        </el-table-column>
-->
                        <el-table-column min-width="90" prop="price" label="Cena" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="140" prop="document" label="Dokument">
                            <template slot-scope="scope">
                                <div v-if="scope.row.document" style="display: flex; gap: 5px; align-items: center;">
                                    <a :href="fileUrl + '/customers/' + scope.row.id + '/' + scope.row.document"
                                        target="_blank"
                                        style="color: #e14eca; text-decoration: underline; cursor: pointer;">
                                        <i class="tim-icons icon-paper"></i> Preuzmi
                                    </a>
                                    <base-button :type="'danger'" class="btn-link btn-sm"
                                        @click="deleteDocument(scope.row)" style="padding: 0; margin: 0;">
                                        <i class="tim-icons icon-trash-simple"></i>
                                    </base-button>
                                </div>
                                <span v-else style="color: #666;">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">

                                <base-button :type="'success'" class="btn-link"
                                    @click="getWhitelistDetails(scope.row, false)">
                                    Detalji
                                </base-button>

                                <base-button v-if="scope.row.status !== 3 && scope.row.status !== 4" :type="'warning'"
                                    class="btn-link" @click="getWhitelistDetails(scope.row, true)">
                                    Produži
                                </base-button>

                                <base-button v-if="scope.row.status === 0 || scope.row.status === 6" :type="'danger'"
                                    class="btn-link" @click="whitelistCustomer = scope.row; showCancelPrompt()">
                                    Otkaži
                                </base-button>

                            </div>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        <modal :show.sync="editWhitelist" :show-close="true" :scrollToBottom="false" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="editWhitelist = false; whitelist = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <card class="stacked-form" title="Pretplatnik">
                <tabs type="primary">
                    <tab-pane label="Podaci">
                        <form @submit.prevent>
                            <div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input required label="Ime" type="text"
                                            v-model="whitelistCustomer.customerName" placeholder="Ime">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <template v-if="whitelistCustomer.id && !whitelistCustomer.extend">
                                            <base-input required label="Tablice">
                                                {{ whitelistCustomer.plates }}
                                            </base-input>
                                        </template>
                                        <base-input v-else required label="Tablice" type="text"
                                            v-model="whitelistCustomer.plates" placeholder="Tablice">
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Država" type="text" v-model="whitelistCustomer.country"
                                            placeholder="Država">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input label="Adresa" type="text" v-model="whitelistCustomer.address"
                                            placeholder="Adresa">
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Matični broj" type="text"
                                            v-model="whitelistCustomer.personalNumber" placeholder="Matični broj">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input required label="Broj telefona" type="text"
                                            v-model="whitelistCustomer.phone" placeholder="Broj telefona">
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Fiskalni račun" type="text"
                                            v-model="whitelistCustomer.fiscalNumber" placeholder="Fiskalni račun">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input required label="Cena" type="text" v-model="whitelistCustomer.price"
                                            placeholder="Cena">
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input required label="Od">
                                            <template v-if="whitelistCustomer.id && !whitelistCustomer.extend">
                                                {{ (new Date(whitelistCustomer.dateFrom)).toLocaleString("de-DE") }}
                                            </template>

                                            <el-date-picker v-else type="datetime" placeholder="Početak"
                                                format="dd.MM.yyyy. HH:mm:ss" value-format="timestamp"
                                                v-model="whitelistCustomer.dateFrom">
                                            </el-date-picker>
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input required label="Do">
                                            <template v-if="whitelistCustomer.id && !whitelistCustomer.extend">
                                                {{ (new Date(whitelistCustomer.dateTo)).toLocaleString("de-DE") }}
                                            </template>

                                            <el-date-picker v-else type="datetime" placeholder="Kraj"
                                                format="dd.MM.yyyy. HH:mm:ss" value-format="timestamp"
                                                v-model="whitelistCustomer.dateTo">
                                            </el-date-picker>

                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Ugovor" type="text"
                                            v-model="whitelistCustomer.contractNumber" placeholder="Ugovor">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input required label="Ugovor važi do">
                                            <el-date-picker type="datetime" placeholder="Ugovor važi do"
                                                format="dd.MM.yyyy. HH:mm:ss" value-format="timestamp"
                                                v-model="whitelistCustomer.contractExpireLong">
                                            </el-date-picker>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Komentar" type="text" v-model="whitelistCustomer.comment"
                                            placeholder="Komentar">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input label="E-Mail" type="text" v-model="whitelistCustomer.email"
                                            placeholder="E-Mail">
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <h4 class="card-title">Dokument</h4>
                                        <div class="upload-area" :class="{ 'drag-over': isDragging }"
                                            @dragover.prevent="isDragging = true"
                                            @dragleave.prevent="isDragging = false" @drop.prevent="handleDrop"
                                            @click="$refs.documentFile.click()">
                                            <input ref="documentFile" type="file" @change="handleFileUpload"
                                                style="display: none;" />
                                            <div v-if="!selectedFile" class="upload-placeholder">
                                                <i class="tim-icons icon-cloud-upload-94"
                                                    style="font-size: 48px; color: #e14eca;"></i>
                                                <p style="color: white;">Prevucite fajl ovde ili kliknite za odabir</p>
                                                <small class="text-muted">PDF, DOCX, JPG, PNG - svi tipovi
                                                    dokumenata</small>
                                            </div>
                                            <div v-else class="selected-file">
                                                <i class="tim-icons icon-paper"
                                                    style="font-size: 32px; color: #00f2c3;"></i>
                                                <div class="file-info">
                                                    <span class="file-name">{{ selectedFile.name }}</span>
                                                    <small class="text-muted">{{ formatFileSize(selectedFile.size)
                                                    }}</small>
                                                </div>
                                                <base-button type="danger" size="sm" icon @click.stop="removeFile">
                                                    <i class="tim-icons icon-simple-remove"></i>
                                                </base-button>
                                            </div>
                                        </div>
                                        <p v-if="whitelistCustomer.document && !selectedFile"
                                            style="color: #00f2c3; margin-top: 10px;">
                                            <i class="tim-icons icon-check-2"></i> Trenutni dokument:
                                            <a :href="fileUrl + '/customers/' + whitelistCustomer.id + '/' + whitelistCustomer.document"
                                                target="_blank"
                                                style="color: #e14eca; text-decoration: underline; cursor: pointer;">
                                                {{ whitelistCustomer.document }}
                                            </a>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </tab-pane>

                    <tab-pane label="Lokacije">
                        <el-select v-model="whitelistCustomer.whitelistType" class="select-primary"
                            @change="getWhitelistTypeParkingsOnly" name="whitelistType" value-key="id">
                            <el-option v-for="t in whitelistTypes" class="select-primary" :label="t.name" :value="t"
                                :key="t.id"></el-option>
                        </el-select>
                        <base-button class="mt-3" native-type="submit" type="primary" @click="markAll()">Selektuj
                            sve</base-button>
                        <el-table :data="whitelistCustomer.parkings" v-loading="ticketsLoading">

                            <el-table-column min-width="80" prop="name" label="Parking">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="100" prop="client" label="Zona">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.client?.name }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="100" prop="checked" label="">
                                <template slot-scope="scope">
                                    <span>
                                        <base-checkbox class="text-left" v-model="scope.row.checked">

                                        </base-checkbox>
                                    </span>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                                <div slot-scope="scope" class="text-right table-actions">

                                    <base-button :type="'success'" class="btn-link"
                                        @click="ticket = scope.row; showTicket = true">
                                        Detalji
                                    </base-button>

                                </div>
                            </el-table-column> -->
                        </el-table>
                    </tab-pane>

                </tabs>
                <template v-if="whitelistCustomer.id">
                    <p style="color: white;">Kreirano: {{ (new
                        Date(whitelistCustomer.stampLong)).toLocaleString("de-De") }}</p>
                    <p style="color: white;">Izmenjeno: {{ (new
                        Date(whitelistCustomer.timeStamp)).toLocaleString("de-De") }}</p>
                </template>

                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="saveWhitelist()">Sačuvaj</base-button>
                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                    @click="editWhitelist = false; whitelistCustomer = false">Odustani</base-button>

                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="getWhitelistHistory()">Istorija</base-button>
            </card>

        </modal>

        <modal :show.sync="showWhitelistHistory" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showWhitelistHistory = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <el-table :data="whitelistHistory">
                <el-table-column min-width="150" prop="number" label="Dogadjaj">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.log }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" prop="active" label="Komentar">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.comment }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Korisnik">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.userName }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Datum">
                    <template slot-scope="scope">
                        <span>
                            {{ (new Date(scope.row.stamp)).toLocaleString("de-DE") }}
                        </span>
                    </template>
                </el-table-column>


            </el-table>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showWhitelistHistory = false;">
                Zatvori
            </base-button>
        </modal>

    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const statuses = [
    { "status": 0, "name": "AKTIVNA" },
    { "status": 1, "name": "ISTEKLA" },
    { "status": 2, "name": "OTKAZANA" },
    { "status": 3, "name": "ISTEKLA I PRODUŽENA" },
    { "status": 4, "name": "OTKAZANA I AKTIVIRANA" },
    { "status": 5, "name": "AKTIVIRANA PRODUŽENA" },
    { "status": 6, "name": "NOVA" }

]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        this.getUserPageFilter()
        this.getWhitelistTypes()
        this.user = JSON.parse(localStorage.getItem("user"));
        // console.log("User", this.user);
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            statuses,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            loading: false,
            filter: {
                pageId: "6",
                startStamp: startStamp,
                endStamp: endStamp,
                name: null,
                plates: null,
                personalNumber: null,
                status: null,
                phone: null
            },
            ticketsLoading: false,
            whitelist: [],
            whitelistCustomer: {},
            editWhitelist: false,
            whitelistTypes: [],
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            sortField: "date_from",
            sortOrder: "descending",
            totalPrice: 0,
            showWhitelistHistory: false,
            whitelistHistory: [],
            user: {},
            selectedFile: null,
            isDragging: false,
            uploading: false
        };
    },
    methods: {
        deleteDocument(whitelist) {
            const swalWithBootstrapButtons = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons
                .fire({
                    title: "Da li ste sigurni da želite da obrišete dokument?",
                    text: whitelist.document,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.loading = true;
                        axios.post(this.url + '/whitelist/deleteWhitelistDocument', { id: whitelist.id })
                            .then(result => {
                                this.loading = false;
                                if (result.data.result === 'ok') {
                                    this.$notify({
                                        message: 'Dokument uspešno obrisan',
                                        timeout: 3000,
                                        icon: 'tim-icons icon-check-2',
                                        horizontalAlign: "right",
                                        verticalAlign: "top",
                                        type: 'success'
                                    });
                                    this.getWhitelist();
                                } else {
                                    this.$notify({
                                        message: result.data.reason,
                                        timeout: 3000,
                                        icon: 'tim-icons icon-bell-55',
                                        horizontalAlign: "right",
                                        verticalAlign: "top",
                                        type: 'danger'
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$notify({
                                    message: 'Greška pri brisanju dokumenta',
                                    timeout: 3000,
                                    icon: 'tim-icons icon-alert-circle-exc',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            });
                    }
                });
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
            }
        },

        handleDrop(event) {
            this.isDragging = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.selectedFile = file;
            }
        },

        removeFile() {
            this.selectedFile = null;
            if (this.$refs.documentFile) {
                this.$refs.documentFile.value = '';
            }
        },

        formatFileSize(bytes) {
            if (bytes < 1024) return bytes + ' B';
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
            return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
        },

        async uploadDocument() {
            if (!this.selectedFile || !this.whitelistCustomer.id) {
                this.$notify({
                    message: 'Morate prvo sačuvati pretplatnika',
                    timeout: 3000,
                    icon: 'tim-icons icon-bell-55',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'warning'
                });
                return;
            }

            const formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('whitelistId', this.whitelistCustomer.id);

            this.uploading = true;
            try {
                const result = await axios.post(this.url + '/whitelist/uploadWhitelistDocument', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Dokument uspešno uploadovan',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.selectedFile = null;
                    if (this.$refs.documentFile) {
                        this.$refs.documentFile.value = '';
                    }

                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            } catch (error) {
                this.$notify({
                    message: 'Greška pri uploadu dokumenta',
                    timeout: 3000,
                    icon: 'tim-icons icon-alert-circle-exc',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'danger'
                });
            } finally {
                this.uploading = false;
            }
        },
        getUserPageFilter() {
            this.loading = true

            axios.get(this.url + '/settings/getUserPageFilter?page=6').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                } else {
                    // this.$notify({
                    //     message:
                    //         result.data.reason,
                    //     timeout: 3000,
                    //     icon: 'tim-icons icon-bell-55',
                    //     horizontalAlign: "right",
                    //     verticalAlign: "top",
                    //     type: 'danger'
                    // });
                }
                this.getWhitelist()
            })
        },
        markAll() {
            for (let i = 0; i < this.whitelistCustomer.parkings.length; i++) {
                this.$set(this.whitelistCustomer.parkings[i], 'checked', true);
            }
        },
        getWhitelistHistory() {
            this.loading = true
            axios.get(this.url + '/whitelist/getWhitelistHistory?id=' + this.whitelistCustomer.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.whitelistHistory = result.data.history
                    this.showWhitelistHistory = true
                } else {

                }
            })
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;

            this.getWhitelist()
        },
        changeP(item) {
            this.page = item
            this.getWhitelist()
        },
        sendMessageToAndroid() {
            // Pozivanje funkcije iz Android-a
            Android.callJavaFunction("Pozdrav iz JavaScript-a!");
        },
        getWhitelistDetails(cust, extend) {
            // whitelistCustomer = scope.row;whitelistCustomer.extend = false; editWhitelist = true
            this.loading = true
            axios.get(this.url + '/whitelist/getWhitelistDetails?id=' + cust.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    if (!extend) {
                        this.whitelistCustomer = result.data.whitelist
                        this.whitelistCustomer.extend = false
                        this.editWhitelist = true
                    } else {
                        this.whitelistCustomer = result.data.whitelist;
                        this.whitelistCustomer.extend = true;
                        this.editWhitelist = true;
                    }
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveWhitelist() {
            this.loading = true
            axios.post(this.url + '/whitelist/saveWhitelist', this.whitelistCustomer).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    if (this.selectedFile) {
                        this.whitelistCustomer.id = result.data.whitelistId; // Dodaj ovo u Java response
                        this.uploadDocument();
                    }
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.whitelistCustomer = {}
                    this.editWhitelist = false
                    this.getWhitelist()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getWhitelistTypes() {
            axios.get(this.url + '/whitelist/getWhitelistTypes').then(result => {

                if (result.data.result === 'ok') {
                    this.whitelistTypes = result.data.whitelistTypes
                } else {

                }
            })
        },
        getWhitelistTypeParkingsOnly() {
            this.loading = true
            axios.post(this.url + '/whitelist/getWhitelistTypeParkingsOnly', this.whitelistCustomer).then(result => {
                this.loading = false
                if (result.data.result === 'ok') {
                    this.whitelistCustomer.parkings = [...result.data.parkings];
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getWhitelist() {
            this.ticketsLoading = true
            this.loading = true
            const f = this.filter
            f.whitelistCategoryId = "1"
            f.page = this.page
            f.max = this.max
            f.sortField = this.sortField
            f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/whitelist/getWhitelist', f).then(result => {
                this.ticketsLoading = false
                this.loading = false

                if (result.data.result === 'ok') {
                    this.whitelist = result.data.whitelist
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        cancelCustomer() {
            this.loading = true

            axios.post(this.url + '/whitelist/cancelWhitelist', this.whitelistCustomer).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Otkazano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getWhitelist()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        showCancelPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da otkažete pretplatnika \"" + this.whitelistCustomer.customerName + "\"?",
                    text: ``,
                    confirmButtonText: "Da, otkaži!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.cancelCustomer()
                    }
                });
        }

    }
};
</script>
<style lang="scss" scoped>
/* Pozadina modala */
.modal-dialog {
    margin-top: 20px !important;
    /* Postavi željeni razmak od vrha */
}

.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.upload-area {
    border: 2px dashed #525f7f;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(0, 0, 0, 0.1);
}

.upload-area:hover {
    border-color: #e14eca;
    background: rgba(225, 78, 202, 0.1);
}

.upload-area.drag-over {
    border-color: #00f2c3;
    background: rgba(0, 242, 195, 0.1);
}

.upload-placeholder p {
    margin: 15px 0 5px 0;
    color: #fff;
}

.selected-file {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.file-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.file-name {
    color: #fff;
    font-weight: 500;
}
</style>